import { styled } from "@linaria/react";
import {
  SectionContainer,
  SectionInner,
} from "components/rhombus-UI/theme/containers";
import { SectionPreTitle } from "components/rui/typography";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

const LogoSectionInner = styled(SectionInner)`
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const LogosRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 2.5rem;
  width: 100%;
`;

const IndustryLogos = ({ logos = [] }) => {
  return (
    <SectionContainer>
      <LogoSectionInner>
        <SectionPreTitle>Trusted by Industry Leaders </SectionPreTitle>
        <LogosRow>
          {logos.map((logo = {}, index) => (
            <GatsbyImage image={getImage(logo)} key={index} />
          ))}
        </LogosRow>
      </LogoSectionInner>
    </SectionContainer>
  );
};

export default IndustryLogos;
